import { useCallback, useEffect, useState } from 'react';

interface IReturn {
  width: number;
  height: number;
}

const getCurrentSizes = () => ({
  width: window.innerWidth,
  height: window.innerHeight,
});

export const useScreenSizes = () => {
  const [sizes, setSizes] = useState<IReturn>(getCurrentSizes);

  const handleResize = useCallback(() => setSizes(getCurrentSizes()), []);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);

  return sizes;
};
